import {
  REQUEST_BULK_USER_UPLOAD,
  REQUEST_BULK_USER_UPLOAD_SUCCESS,
  SET_BULK_USER_UPLOAD_STAGE,
  RESET_BULK_USER_UPLOAD_STATE,
} from 'Store/Areas/BulkUpload/BulkUserUploadActions';
import { bulkUserUploadImportStages } from 'Constants/BulkUpload/BulkUserUploadStages';

const initialState = {
  loading: false,
  stage: bulkUserUploadImportStages.uploading,
  importMessages: [],
  hasImportMessages: false,
  userId: -1,
};

export default function bulkUploadReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_BULK_USER_UPLOAD:
      return Object.assign({}, state, {
        loading: true,
      });
    case REQUEST_BULK_USER_UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        userId: action.userId,
      });
    case SET_BULK_USER_UPLOAD_STAGE:
      return Object.assign({}, state, {
        stage: action.stage,
        importMessages: action.importMessages,
        hasImportMessages: action.importMessages && action.importMessages.length > 0,
        loading: action.stage === bulkUserUploadImportStages.uploading
          || action.stage === bulkUserUploadImportStages.passedScan,
      });
    case RESET_BULK_USER_UPLOAD_STATE:
      return initialState;
    default:
      return state;
  }
}
